import request from '../setup/request';
const www = {
  /**
   * 获取首页轮播图片
   */
  getHomeBanner(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.banner.getlist',
    });
  },
  /**
   * 获取新闻列表
   */
  getNewsList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.news.getlist',
    });
  },
  /**
   * 获取新闻详情
   */
  getNewsInfo(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.news.getinfo',
    });
  },
  /**
   * 获取公告列表
   */
  getNoticeList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.notice.getlist',
    });
  },
  /**
   * 获取公告详情
   */
  getNoticeInfo(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.notice.getinfo',
    });
  },
  /**
   * 获取页面列表
   */
  getPageList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.page.getpagelist',
    });
  },
  /**
   * 获取页面详情
   */
  getPageInfo(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.page.getinfo',
    });
  },
  /**
   * 获取内容列表
   */
  getContentList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.content.getlist',
    });
  },
  /**
   * 获取内容详情
   */
  getContentInfo(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.content.getinfo',
    });
  },
  /**
   * 获取广告详情
   */
  getAdvertInfo(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.advert.getinfo',
    });
  },
  /**
   * 获取友情链接
   */
  getLinksList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.links.getlist',
    });
  },
  /**
   * 提交投诉建议
   */
  addFeedback(params) {
    return request.post('', {
      ...params,
      method: 'ih.workflow.client.submitTicket',
    });
  },
  /**
   * 获取住宿列表
   */
  getStayList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.stay.getlist',
    });
  },
  /**
   * 获取餐饮列表
   */
  getFoodList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.food.getlist',
    });
  },
  /**
   * 获取导游列表
   */
  getGuideList(params) {
    return request.post('', {
      ...params,
      method: 'ih.cms.cicerone.getlist',
    });
  },
  /**
   * 获取实时入园信息
   */
  getQueryRealtime(params) {
    return request.post('', {
      ...params,
      method: 'ih.ticketdc.query.realtime',
    });
  },
  /**
   * 获取停车位信息
   */
  getParkingInfo(params) {
    return request.post('', {
      ...params,
      method: 'ih.public.parking.info',
    });
  },
  /**
   * 获取天气
   */
  // getWeather(params) {
  //   console.log('api-----params---', params);
  //   return axios.request({
  //     url: 'http://yun-dev202.smallpay.com/da-dcapi/extra/common/weather',
  //     params: params,
  //     method: 'get',
  //   });
  // },
};
export default www;
